module.exports = __webpack_public_path__ + "static/media/image_4.84c14771.png";